module.exports = __webpack_public_path__ + "static/logo-project-tsehigh-a5e7f1a71e089309196ba16b72c4f3fa.png";